<template>
  <div :class="bgColor"  class="flex relative flex-col px-6 pt-6 pb-3 w-full max-md:px-5 max-md:max-w-full">

    <div class="flex gap-5 justify-between self-left w-full  max-md:flex-wrap max-md:max-w-full">
      <div class="flex gap-5 justify-between whitespace-nowrap max-md:flex-wrap max-md:max-w-full">
        <router-link to="/">
          <div class="flex gap-2">
            <div :class="titleColor" class="my-auto text-3xl ">瑜威</div>
          </div>
        </router-link>
        <div :class="titleColor" class="flex gap-14 ml-28 justify-between my-auto text-lg max-lg:gap-8 max-md:gap-4 max-md:ml-4 max-md:flex-wrap">

          <div class="p-2.5"><router-link to="/products">产品方案</router-link></div>
          <div class="p-2.5"><router-link to="/application">应用场景</router-link></div>
          <div class="p-2.5"><router-link to="/honor">荣誉展示</router-link></div>
          <div class="p-2.5"><router-link to="/about">联系我们</router-link></div>

        </div>
      </div>

      

      <div :class="searchBarColor" class="invisible flex flex-col self-right items-end px-16 py-1.5 my-auto rounded-[45px] max-lg:hidden">
        <img loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/2c1cf1c0bfccd8b724b86a26f011607b9eb038bbbad461cbd18260fa28c1f50c?"
          class="aspect-[0.94] w-[17px]" />
      </div>
    </div>

  </div>

  <div>
                <div :class="dividerColor" class="h-px mx-4 mt-2"></div>
            </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    theme: {
      type: String,
      required: true,
      validator(value) {
        return ['light', 'dark'].includes(value);
      },
    },
  },
  computed: {
    titleColor() {
      return {
        'text-black': this.theme === 'light',
        'text-white': this.theme === 'dark',
      };
    },
    searchBarColor() {
      return {
        'bg-stone-300': this.theme === 'light',
        'bg-white': this.theme === 'dark',
      };
    },
    borderColor() {
      return {
        'border-black': this.theme === 'light',
        'border-white': this.theme === 'dark',
      };
    },
    bgColor() {
      return {
        '': this.theme === 'dark',
        'bg-white': this.theme === 'light',
      };
    },
    dividerColor(){
      return {
        'bg-white': this.theme === 'dark',
        'bg-black': this.theme === 'light',
      };
    },
  },

};
</script>